<template>
  <div class="profile-menu-wrapper">
    <v-menu location="bottom">
      <template v-slot:activator="{ props }">
        <v-btn
          icon
          v-bind="props"
          variant="text"
          size="large"
          class="profile-menu-button"
        >
          <v-icon size="48" color="primary">mdi-account-circle</v-icon>
        </v-btn>
      </template>
      <v-list density="compact">
        <v-list-item @click="goToProfile" prepend-icon="mdi-account">
          <v-list-item-title>Profile</v-list-item-title>
        </v-list-item>
        <v-list-item @click="handleLogout" prepend-icon="mdi-logout">
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import authService from '../services/auth'

const router = useRouter()

const goToProfile = () => {
  router.push({ name: 'Profile' })
}

const handleLogout = () => {
  authService.logout()
}
</script>

<style scoped>
/* Pinned to the right of the header and centred against it, whatever height the
   header ends up being (the brand title changes size across breakpoints). */
.profile-menu-wrapper {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  line-height: 0;
}

.profile-menu-button {
  border: none !important;
  background-color: transparent !important;
}
</style>
